<template lang="pug">
//- Card de uma promoção disponível para ativação na tela de Marketing.
.campanhaPreview(:class="{ 'campanhaPreview--bloqueado': bloqueado }")
  .campanhaPreview__header
    .campanhaPreview__header-title
      span.campanhaPreview__nome.Poppins {{ promo.campanha_nome }}
      span.campanhaPreview__novidade.Poppins(v-if="isNovidade")
        v-icon(size="11", color="#1D7D4A") auto_awesome
        | Novidade
    .campanhaPreview__descricao.Poppins(v-if="promo.campanha_descricao") {{ promo.campanha_descricao }}
  .campanhaPreview__item
    v-img.campanhaPreview__foto(
      v-if="promo.imagem && !promo.imagemQuebrada",
      :src="`${urlImagem}/item/${promo.imagem}`",
      width="56",
      height="56",
      @error="onImagemErro"
    )
    .campanhaPreview__foto-ph(v-else)
      v-icon(size="26", color="#bdbdbd") fastfood
    .campanhaPreview__info
      .campanhaPreview__linha-nome
        span.campanhaPreview__item-nome.Poppins {{ promo.nome }}
        span.campanhaPreview__desconto.Poppins −{{ promo.percentualDesconto }}%
        span.campanhaPreview__segmentado.Poppins(v-if="isSegmentada") PÚBLICO SEGMENTADO
        span.campanhaPreview__aberto.Poppins(v-else) PÚBLICO ABERTO
      .campanhaPreview__precos.Poppins
        | De
        span.campanhaPreview__preco-de R$ {{ formatPrice(promo.preco) }}
        span.campanhaPreview__preco-por R$ {{ formatPrice(promo.preco_promocional) }}
      .campanhaPreview__subsidio.Poppins(v-if="Number(promo.valorSubsidio) > 0")
        | SUBSÍDIO BIGOU · Bigou paga R$ {{ formatPrice(promo.valorSubsidio) }} · você concede R$ {{ formatPrice(descontoLojista) }}
      ultima-alteracao.campanhaPreview__alteracao(
        :log="ultimaAlteracao",
        @click="$emit('historico', promo)"
      )
    v-btn.campanhaPreview__cta.elevation-0.white--text.Poppins(
      :class="{ 'campanhaPreview__cta--bloqueado': bloqueado }",
      @click="$emit('ativar', promo)"
    )
      span(v-if="bloqueado") 🔒 Ativar
      span(v-else) Ativar
</template>

<script>
import { isNovidadePromo } from '@/util/promocao';
import UltimaAlteracao from '@/components/marketing/UltimaAlteracao';

export default {
  name: 'CampanhaPreviewCard',
  components: {
    UltimaAlteracao,
  },
  props: {
    promo: { type: Object, required: true },
    bloqueado: { type: Boolean, default: false },
    ultimaAlteracao: { type: Object, default: null },
  },
  computed: {
    urlImagem() {
      return process.env.VUE_APP_IMAGE_URL;
    },
    isNovidade() {
      return !!(this.promo && isNovidadePromo(this.promo));
    },
    isSegmentada() {
      return !!(this.promo && this.promo.publico_nomes && String(this.promo.publico_nomes).trim());
    },
    descontoLojista() {
      const desconto = Number(this.promo.desconto) || 0;
      const subsidio = Number(this.promo.valorSubsidio) || 0;
      const liquido = desconto - subsidio;
      return liquido > 0 ? liquido : 0;
    },
  },
  methods: {
    formatPrice(value) {
      if (!value && value !== 0) return '-';
      return Number(value).toFixed(2).replace('.', ',');
    },
    onImagemErro() {
      this.$set(this.promo, 'imagemQuebrada', true);
    },
  },
};
</script>

<style lang="scss" scoped>
.campanhaPreview {
  background: #fff;
  border: 1px solid #ECECEE;
  border-radius: 14px;
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
  transition: box-shadow 0.18s ease, transform 0.18s ease;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    transform: translateY(-2px);
  }

  &--bloqueado {
    opacity: 0.6;
    filter: grayscale(30%);
    &:hover {
      box-shadow: none;
      transform: none;
    }
  }

  &__header {
    background: #FFF8EC;
    border-bottom: 1px solid #F5E3C2;
    padding: 11px 16px;
  }
  &__header-title {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }
  &__nome {
    font-size: 13px;
    font-weight: 700;
    color: #1E2330;
  }
  &__descricao {
    font-size: 11px;
    color: #8A6420;
    line-height: 1.4;
    margin-top: 2px;
  }

  &__item {
    padding: 14px 16px;
    display: flex;
    gap: 14px;
    align-items: center;
    flex: 1;
  }
  &__foto {
    flex: 0 0 56px;
    width: 56px !important;
    height: 56px !important;
    border-radius: 12px;
  }
  &__foto-ph {
    flex: 0 0 56px;
    width: 56px;
    height: 56px;
    border-radius: 12px;
    background: #ECECEC;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__info {
    flex: 1;
    min-width: 0;
  }
  &__linha-nome {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }
  &__item-nome {
    font-size: 13px;
    font-weight: 700;
    color: #1E2330;
  }
  &__novidade {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    background: #DCEFE4;
    color: #1D7D4A;
    font-size: 10px;
    font-weight: 700;
    padding: 2px 8px;
    border-radius: 999px;
    text-transform: uppercase;
    letter-spacing: 0.3px;
  }
  &__desconto {
    background: #FFE55C;
    color: #5C4A00;
    font-size: 10.5px;
    font-weight: 700;
    padding: 2px 7px;
    border-radius: 999px;
  }
  &__segmentado {
    background: #EEEAFB;
    color: #5B4BC4;
    font-size: 9.5px;
    font-weight: 700;
    padding: 2px 7px;
    border-radius: 999px;
  }
  &__aberto {
    background: #EDF0F3;
    color: #5B6472;
    font-size: 9.5px;
    font-weight: 700;
    padding: 2px 7px;
    border-radius: 999px;
  }
  &__precos {
    font-size: 12px;
    color: #9CA3AF;
    margin-top: 2px;
    display: flex;
    align-items: baseline;
    gap: 6px;
  }
  &__preco-de {
    text-decoration: line-through;
  }
  &__preco-por {
    color: #1E9E57;
    font-weight: 700;
    font-size: 14px;
  }
  &__subsidio {
    font-size: 11px;
    color: #B96A00;
    font-weight: 600;
    margin-top: 3px;
  }
  &__alteracao {
    margin-top: 6px;
  }
  &__cta {
    background: #F08C00 !important;
    border-radius: 9px !important;
    text-transform: none !important;
    font-weight: 600 !important;
    font-size: 12px !important;
    letter-spacing: 0 !important;
    height: 36px !important;
    min-width: 76px !important;
    margin: 0 !important;
    flex-shrink: 0;
    &--bloqueado {
      background: #E3E3E6 !important;
      color: #9CA3AF !important;
    }
  }

  @media (max-width: 600px) {
    &__item { flex-wrap: wrap; }
    &__cta { width: 100%; }
  }
}
</style>
